import React, { Component } from 'react';
import ReactDOM from 'react-dom';

import Utils from './Utils.js';
import XHR from './xhr/xhr.js';
import XHRCheckout from './xhr/checkout.js';

let PayPalButtonComponent = window.paypal.Button.driver('react', { React, ReactDOM });

class PaypalButton extends Component {
  constructor(props) {
    super(props);

    this.state = {
      env: process.env.REACT_APP_PAYPAL_ENV,
      client: {
        sandbox:    'AbYarIB-zlS7t8tvRAZlQJkF2i-x4chu5icEVxoZxmGAwHNIqtMD0b9mVz69g9nqyOb8na1Lca-IKmR_',
        production: 'Aatn2n-mIxLsKmbFXoBsrJMWedxxsV7pt8350Cp9x9D9AXQivNQbFqGh6UnOOPY46OTSZaKY3UMNQCDN',
      },
      commit: true,

      price: props.price,
      currency: props.currency,
      asset_uid: props.asset_uid,
      type: props.type,
      options: props.options,
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      price: nextProps.price,
      currency: nextProps.currency,
      asset_uid: nextProps.asset_uid,
      type: nextProps.type,
      options: nextProps.options,
    });
  }

  payment() {
    let req = {
      payment: 'paypal_create',
      amount: this.state.price,
      options: Utils.stringifyOpts(this.state.options),
      currency: this.state.currency,
      asset_uid: this.state.asset_uid,
      type: this.state.type,
    }

    return XHR.postJson(
      XHR.domain + '/api/account/checkout',
      null,
      req,
    ).then((resp) => {
      if (resp.ok && resp.redirect) {
        setTimeout(() => { document.location = resp.redirect; }, 1000);
        return
      } else if (resp.id) {
        return resp.id;
      }
      // TODO(remy): error
    })
  }
  onAuthorize(data) {
    let req = {
      payment: 'paypal',
      payer_id: data.payerID,
      payment_id: data.paymentID,
      amount: this.state.price,
      // TODO(remy): email
      options: Utils.stringifyOpts(this.state.options),
      currency: this.state.currency,
      asset_uid: this.state.asset_uid,
      type: this.state.type,
    }

    XHRCheckout.checkout(req).then((resp) => {
      if (resp.ok) {
        if (resp.redirect) {
          document.location = resp.redirect;
        } else {
          document.location.hash = '/download/'+this.state.type+'/'+this.state.asset_uid;
        }
      }
    });
  }
  render() {
    return (
      <PayPalButtonComponent
      style={{size: 'medium', shape: 'rect'}}
      commit={ this.state.commit }
      env={ this.state.env }
      client={ this.state.client }
      payment={ (data, actions) => this.payment(data, actions) }
      onAuthorize={ (data, actions) => this.onAuthorize(data, actions) }
      />
    );
  }
}


export default PaypalButton;



// WEBPACK FOOTER //
// ./src/PaypalButton.js